export const appVersion = '0.2.4';
